import { render, staticRenderFns } from "./NavegationTabs.vue?vue&type=template&id=a58ae110&"
import script from "./NavegationTabs.vue?vue&type=script&lang=js&"
export * from "./NavegationTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports